<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="recovery-password-container">
        <img src="../assets/appIcons/Pics/Flag.png" id="flag" alt="">
        <div class="row">
            <div class="col-lg-5">
                <div id="recovery-password-container-form-content">
                    <form v-on:submit.prevent="handelSubmit">
                        <div id="title">تغییر رمز عبور</div>
                        <div class="form-group">
                            <div class="input-group">
                                <div class="text-field">
                                    <input v-model="data.password" class="form-control password-input" :type="visibility" required>
                                    <label>رمز عبور جدید</label>
                                    <a class="eye-icon" v-if="data.password" v-on:mouseover="showPassword"  v-on:mouseleave="hidePassword">
                                        <span v-if="visibility=='password'">
                                             <span class="iconify" data-icon="clarity:eye-hide-line" data-inline="false"></span>
                                        </span>
                                        <span v-if="visibility=='text'">
                                              <span class="iconify" data-icon="akar-icons:eye" data-inline="false" style="color: #fe7063"></span>
                                        </span>
                                    </a>
                                </div>
                                <div class="text-field">
                                    <input v-model="data.password_confirmation" class="form-control password-input" :type="visibility" required>
                                    <label>تکرار رمز عبور جدید</label>
                                    <a class="eye-icon" v-if="data.password_confirmation" v-on:mouseover="showPassword"  v-on:mouseleave="hidePassword">
                                        <span v-if="visibility=='password'">
                                             <span class="iconify" data-icon="clarity:eye-hide-line" data-inline="false"></span>
                                        </span>
                                        <span v-if="visibility=='text'">
                                              <span class="iconify" data-icon="akar-icons:eye" data-inline="false" style="color: #fe7063"></span>
                                        </span>
                                    </a>
                                </div>


                            </div>
                        </div>
                        <button type="submit" style="display: none">submit</button>
                    </form>
                    <div>
                        <button type="submit"  v-on:click="handelSubmit" class="btn btn-success btn-block">تغییر رمز عبور</button>
                    </div>

                </div>
            </div>
            <div class="col-7 img-content">
                <div id="img-content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import  Alert from '../components/Alert'
    import axios from 'axios'
    export default {
        name: "PasswordRecovery",
        components:{
            Alert,
        },
        data(){
            return {
                alertContent:null,
                loadingMood:false,
                data:{email:localStorage.getItem('email'),password:null,password_confirmation:null,token:this.$route.params.token}
            }
        },
        methods:{
            async handelSubmit() {
                try {
                    this.loadingMood=true;
                    let response = await axios.post('api/authentication/password/reset' ,this.data);
                    this.loadingMood=false;
                    console.log(response);
                    // let token = response.data.token;
                    // localStorage.setItem('token',token);
                    // let email = response.data.user.email;
                    // localStorage.setItem('email',email);
                    this.alertContent={
                        message: 'رمز عبور شما با موفقیت تغییر کرد!',
                        notice:'',
                        imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'link',//link
                        buttonText:'صفحه ی ورود',
                        buttonLink:'/user-signin',///personal-info
                        waitingMode:false
                    };
                }catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        notice:error.response.data.errors,
                        imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',
                        buttonText:'تایید',
                        closeButtonShow:true,
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }
            },
        }
    }
</script>

<style scoped>


    button:hover{
        background-color: #fe7063;
        border: none;
    }
    #detail-txt{
        width: 100%;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
    }
    #detail-txt>a{
        color: #162336;
        text-decoration: underline;
    }
    button{
        max-width: 305px;
        width: 100%;
        min-height: 50px;
        border-radius: 5px;
        background-color: #162336;
        margin: 0 0 10px;
        padding: 11px 41px;
        font-size: 16px;
    }
    form>.form-group{
        margin-top: 50px;
    }

   .password-input{
        text-align: left;
    }

    .text-field {
        width: 100%;
        position: relative;
        margin: 30px 2.5px 20px 2.5px;
    }
    .text-field:nth-child(2) {
        margin-top: 10px;
    }


    input:focus {
        border: thin solid #32cd32;
        border-bottom: solid medium #32cd32;
        background-color:#fff;
    }

    label {
        position: absolute;
        pointer-events: none;
        right: 10px;
        top: 5px;
        transition: 0.2s;
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        opacity: 1;
    }

    input:focus ~ label, input:valid ~ label {
        top: -12px;
        right: 15px;
        font-size: small;
        color:  #fe7063;
        padding:0 5px 0 5px;
        background-color: white;

    }




    input{
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        max-width: 300px;
        width: 100%;
        height: 40px;
        border-radius: 5px!important;
        opacity: 0.5;
        border: solid 0.5px #162336;
    }
    #title{
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }

    input:focus{
        border: solid 2px #fe7063!important;
    }
    *:focus {
        border: solid 0.5px #162336!important;
    }
    #recovery-password-container-form-content{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        max-width: 370px;
        margin: auto;
        height: 518px;
        padding: 15px 30px 20px;
        border-radius: 10px;
        box-shadow: 0 0 12px 0 rgba(22, 35, 54, 0.2);
        background-color: #ffffff;
    }
    #recovery-password-container-form-content>form{
        margin-top: 50px;
    }
    #flag{
        left: 0;
        top: 0;
        opacity: 0.05;
        height: 100%;
        width: 100%;
        position: absolute;
    }
    #img-content{
        width: 100%;
        height: 517px;
        margin: 35px auto;
        background-image: url("../assets/appIcons/Pics/Login.png");
        background-size: cover;
        background-repeat: no-repeat;
    }
    #recovery-password-container{
        position: relative;
        height: auto;
        background-color: white;
        width: 100%;
        max-width: 970px;
        padding: 30px;
        margin: auto auto 50px auto;
        border-radius: 10px;
    }

    @media (max-width: 1000px) {
        .img-content{
            display: none;
        }
        .img-content{
            display: none;
        }
        #flag{
            display: none;
        }
        #recovery-password-container{
            background-color: transparent;
        }
        .img-content{
            display: none;
        }

    }
</style>